import { useEffect } from 'react'
import { initStorage } from 'shared/lib/storage'
import { useStartParamRoute } from 'shared/lib/telegram/use-start-param-route'

export const AppInitializers = () => {
	useStartParamRoute()

	useEffect(() => {
		initStorage()
	}, [])

	return null
}
